import { IconClose } from '@/styles/Icon'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
export interface DrawBottomProps {
  open: boolean
  children: JSX.Element[] | JSX.Element
  title?: string
  titleClassName?: string
  bodyClassName?: string
  mainClassName?: string
  onClose: () => void
  scroll?: boolean
  hideClose?: boolean
}

export function DrawBottom({
  open,
  children,
  title,
  scroll,
  hideClose = false,
  mainClassName = '',
  titleClassName = '',
  bodyClassName = '',
  onClose,
}: DrawBottomProps) {
  const completeButtonRef = useRef(null)
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        initialFocus={completeButtonRef}
        as='div'
        className={`relative z-[9999]`}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 left-0 bottom-0 bg-black-150 transition-opacity' />
        </Transition.Child>
        <div
          className={` ${mainClassName} pointer-events-none z-50 w-full overflow-hidden fixed left-[50%] translate-x-[-50%] rounded-tr-sm rounded-tl-sm bottom-0 flex max-h-[70vh] h-full max-w-[440px] `}
        >
          <Transition.Child
            as={Fragment}
            enter='transform transition ease-in-out duration-500'
            enterFrom='translate-y-[70%]'
            enterTo='translate-y-[0%]'
            leave='transform transition ease-in-out duration-500'
            leaveFrom='translate-y-[0%]'
            leaveTo='translate-y-[100%]'
          >
            <Dialog.Panel className='pointer-events-auto w-full max-w-[440px] h-full shadow-modal'>
              <div
                className={`bg-white pb-4 block transform overflow-hidden align-middle shadow-modal w-full`}
              >
                <div
                  className={`headerModal relative w-full px-2 pb-3 ${titleClassName} ${
                    title != '' ? 'pt-4 h-[72px]' : ''
                  }`}
                >
                  {title != '' && (
                    <Dialog.Title as='h2' className={`text-titleSection`}>
                      {title}
                    </Dialog.Title>
                  )}
                  <button
                    onClick={onClose}
                    className={`absolute right-3 top-4 cursor-pointer z-10`}
                  >
                    {!hideClose && <IconClose />}
                  </button>
                </div>
                <div
                  className={`${bodyClassName} ${
                    title != ''
                      ? 'max-h-[calc(70vh-88px)] min-h-[calc(70vh-88px)]'
                      : 'max-h-[70vh] min-h-[70vh]'
                  } max-w-[calc(100%-8px)] mr-2 pl-3 pr-2  h-full ${
                    scroll ? 'scrollBarCS' : 'hiddenScrollBar overflow-y-auto'
                  }`}
                >
                  {children}
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default DrawBottom
